/* eslint-disable react/prop-types */
import React, { useState } from 'react' // eslint-disable-line import/no-unresolved

/* Components */
import { Canvas } from 'react-three-fiber' // eslint-disable-line import/no-unresolved
import Field from './Field/Field'
import Camera from './Scene/Camera'
import Trajectory from './Events/Trajectory'
import SprayChart from './Events/SprayChart'

function ThreeD({ settings, chartOptions = {} }) {
    // Dynamically set the class after last spray item is added
    const [id, setId] = useState('')

    // Default position is behind home plate 200ft high
    let defaultCameraPosition = [0, -150, 200]
    let defaultCameraLookAt = [0, 127, 0]

    if (chartOptions.view === 'birdsEye') {
        defaultCameraPosition = [0, 197, 425]
        defaultCameraLookAt = [0, 197, 0]
    } else if (chartOptions.view === 'homeLow') {
        defaultCameraPosition = [0, -120, 45]
        defaultCameraLookAt = [0, 127, 0]
    } else if (chartOptions.view === 'cf') {
        defaultCameraPosition = [0, 650, 225]
        defaultCameraLookAt = [0, 127, 0]
    }

    const scene = {
        cameraPosition: defaultCameraPosition,
        cameraLookAt: defaultCameraLookAt,
        count: 0,
    }

    const chart = []

    if (chartOptions.overlayType === 'spray') {
        chart.push(
            <SprayChart
                key="spray-chart"
                settings={settings}
                isFinished={(isFinished) => {
                    if (isFinished) {
                        setId('three-canvas')
                    }
                }}
                chartOptions={chartOptions}
            />
        )
    }
    if (chartOptions.overlayType === 'trajectory') {
        settings.data.forEach((d, i) => {
            let color = chartOptions.color || '#ff0000'
            if (
                chartOptions.legend &&
                chartOptions.legendType === 'homeRunTypes'
            ) {
                if (d.hrCategory === 'No Doubter') {
                    color = '#ff5722'
                } else if (d.hrCategory === 'Mostly Gone') {
                    color = '#3a9098'
                } else {
                    color = '#9e9e9e'
                }
            }
            chart.push(
                <Trajectory
                    key="trajectory"
                    settings={settings}
                    isAnimated={false}
                    color={color}
                    type="catmull"
                    polynomial={d}
                    lastUpdate={settings.data.length === i + 1}
                    isFinished={(lastUpdate) => {
                        if (lastUpdate) {
                            setId('three-canvas')
                        }
                    }}
                />
            )
        })
    }

    return (
        <Canvas className={id}>
            <ambientLight />
            <pointLight
                // eslint-disable-next-line react/no-unknown-property
                position={[0, -100, 10]}
                // eslint-disable-next-line react/no-unknown-property
                intensity={0.5}
                color="#f5f5f5"
            />
            <Camera
                position={scene.cameraPosition}
                lookAt={scene.cameraLookAt}
                isAnimating={false}
            />
            <Field
                id={settings.venueId}
                position={[0, 0, 0]}
                showStadiumName
                stadium={{ name: 'Kauffman Stadium', id: 3 }}
            />
            {chart}
        </Canvas>
    )
}

export default ThreeD
